import { Component, HostListener, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription, lastValueFrom } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { TaskModalComponent } from './task-modal/task-modal.component';
import { ActivatedRoute, Event, Router, RoutesRecognized } from '@angular/router';
import { TaskStatusesFilterOptions } from './task.constants';
import { ITask, ITaskFilter } from './task.interface';
import { TaskHttpService } from './task-http.service';
import { Overlay } from '@angular/cdk/overlay';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ICategory } from '../../categories-page/categories/categories.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { CategoriesService } from '../../categories-page/categories/categories.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { AlertService } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/auth.service';
import { BillingDocumentService } from '../../billing-documents-page/billing-documents/billing-documents.service';
import { SettingsService } from '../../settings-page/settings/settings.service';
import { SETTINGS } from '../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { ExternalRequestModalComponent } from '../../../shared/components/external-request/external-request-modal/external-request-modal.component';
import { IInformationDialogOptions } from '../../../shared/services/dialog/information-dialog/information-dialog-options.interface';
import { HelpVideoModalComponent } from '../../../shared/components/help-video-modal/help-video-modal.component';
import { BillingDocumentsModalComponent } from '../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { IBillingDocumentTypes } from '../../billing-documents-page/billing-documents/billing-documents.interface';

let self: any;

@Component({
  selector: 'app-task-complete',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.css']
})
export class TaskComponent implements OnInit {
  tasks: ITask[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: ITaskFilter = {
    filters: {
      dateEnd: new Date().toISOString().substring(0, 10),
      status: 'ACTIVE'
    },
    sort: '-scheduledStart',
    skip: 0,
    limit: 20
  };
  filterAllData: any = {
    sort: '',
    skip: 0,
    limit: 4,
    filters: {}
  };
  filtered = false;
  scrollSubscription!: Subscription;
  routesSubscription!: Subscription;
  querySubscription!: Subscription;
  sortOptions: any = {
    "title": 'Titulo asc',
    "-title": 'Titulo desc',
    "status": 'Estado asc',
    "-status": 'Estado desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  taskStatuses: any = TaskStatusesFilterOptions;
  taskStatusesKeys = Object.keys(TaskStatusesFilterOptions);
  isDev!: boolean;
  bulkInvoicing: boolean = false;
  curr!: string;
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;
  taskStatusColors: any = {};
  categories: ICategory[] = [];
  isMobile: boolean = false;
  noProject: boolean = false;

  constructor(
    public _TaskHttpService: TaskHttpService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    public _CategoriesService: CategoriesService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _UtilsService: UtilsService,
    private _AlertService: AlertService,
    private _AuthService: AuthService,
    private _BillingDocumentService: BillingDocumentService,
    private _UtilService: UtilsService,
    private overlay: Overlay,
    private sanitizer: DomSanitizer,
    private _SettingsService: SettingsService,
    private breakpointObserver: BreakpointObserver,
  ) {
    self = this;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/JT1Zf8dQCAk?si=X8J5MFkEm7ZMSbYE");
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {
      this.bulkInvoicing = false;

      if (!this.filter.filters) this.filter.filters = {};

      if (params['status'] && parseInt(params['tp'] || '0') > (new Date().getTime() - (10 * 1000))) {

        this.filter.filters.status = 'ACTIVE';

        if (params['status'] == 'OPEN') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }));
        }
        else if (params['status'] == 'QUOTED') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }, undefined, false));
        }
        else if (params['status'] == 'SCHEDULED') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }, true, false));
        }
        else if (params['status'] == 'ONGOING') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }));
        }
        else if (params['status'] == 'COMPLETED') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }));
        }
        else if (params['status'] == 'CANCELLED') {
          setTimeout(() => this.openTasksModal({ status: params['status'] }));
        }
        else {
          setTimeout(() => this.openTasksModal({ status: 'OPEN' }));
        }

        this.lazySearch();
      }

      if (params['action'] == 'INVOICE') {
        this.filter.filters.status = 'COMPLETED';
        this.filter.limit = 10000;
        this.noProject = true;

        // to avoid fetching first time
        if (!this.bulkInvoicing) this.bulkInvoicing = true;
        else this.getTasks(true);
      }
    })
  }

  ngOnInit() {
    this.isMobile = this.isMobileWidth();
    const customBreakpoint = this.breakpointObserver.observe([
      `(max-width: 991px)`
    ]);

    customBreakpoint.subscribe((state: BreakpointState) => {
      this.isMobile = state.matches;
    });
    this.getStatusColors();
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.filterAllData.company = this.filter.company;
    this._TaskHttpService.getTasks(this.filterAllData).subscribe((tasks: any) => {
      this.totalMoreMinTutorial = tasks.length > 3;
    });

    this._CategoriesService.getCategories({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'name',
      skip: 0,
      limit: 1000
    }).subscribe((categories) => {
      this.categories = categories;
    });

    this.getTasks(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      // console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTasks(true);
      }
    }, 1000);
  }

  getTasks(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.tasks = [];
      this.clearSelection();
    }
    const filter: any = _.cloneDeep(this.filter);
    /*
    if (_.get(filter, 'filters.created_at_start'))
      filter.filters.created_at_start = new Date(filter.filters.created_at_start).getTime();
    if (_.get(filter, 'filters.created_at_end'))
      filter.filters.created_at_end = new Date(filter.filters.created_at_end).getTime();
      */
    // if (filter.filters.client == '') delete filter.filters.client;
    // if (filter.filters.title == '') delete filter.filters.title;
    // console.log(filter);

    if (filter.filters.dateStart)
      filter.filters.dateStart = this._UtilsService.date.toUTC(filter.filters.dateStart + 'T00:00:00.000Z');
    if (filter.filters.dateEnd)
      filter.filters.dateEnd = this._UtilsService.date.toUTC(filter.filters.dateEnd + 'T23:59:59.999Z');

    this._TaskHttpService.getTasks(filter).subscribe((tasks: any) => {
      if (this.noProject) {
        let taskFiltered = tasks.filter((task: any) => !task.project);
        this.tasks = _.concat(this.tasks, taskFiltered);
        this.thereAreMore = taskFiltered.length >= filter.limit;
      } else {
        this.tasks = _.concat(this.tasks, tasks);
        this.thereAreMore = tasks.length >= filter.limit;
      }
      this.loading = false;
      // console.log(tasks)
    })
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getTasks();
    }
  }

  isMobileWidth(): boolean {
    if (typeof window !== 'undefined' && window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  sortTasks(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort :
      ((sort.direction == 'asc') ? sort.active : ((sort.direction == 'desc') ? '-' + sort.active : ''));
    this.getTasks(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTasks(true);
  }

  openNewTaskModal(selected: string) {
    (selected === 'SCHEDULED') ? this.openTasksModal({ status: selected }, true, false) : this.openTasksModal({ status: selected }, undefined, false);
  }

  openTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.scrollStrategy = this.overlay.scrollStrategies.block();
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  async openDuplicateTaskModal(task: ITask, readOnly: boolean = false) {
    task = await lastValueFrom(this._TaskHttpService.getTask(task));

    const modalOptions: IConfirmationDialogOptions = {
      title: "Duplicar Trabajo",
      message: "Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let data = _.cloneDeep(task);
          data.status = 'SCHEDULED';

          delete data._id;
          delete data.createdAt;
          delete data.createdBy;
          delete data.scheduledStart;
          delete data.scheduledEnd;
          delete data.appointment;
          // console.log(data)

          let config = new MatDialogConfig();
          // config.disableClose = true;
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(TaskModalComponent, config);
          self.dialogRef.componentInstance.task = data;
          // self.dialogRef.componentInstance.readOnly = readOnly;
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.scheduling = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            self.dialogRef = null;
            if (result) this.getTasks(true);
          });
        }
      });
  }

  openExternalRequestModal(task: ITask) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.dialogRef.componentInstance.task = task;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }


  openDeleteUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Disculpas por las molestias",
      message: "Por el momento, no es posible eliminar trabajos.\nHemos identificado un problema con esta funcionalidad que resolveremos a la brevedad.\nPuedes desasignar a tu personal para que no vea más el trabajo en su app móvil.",
      closeButtonLabel: "Aceptar"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok');
      });
  }

  openDeleteTaskConfirm(task: ITask, hardDelete: boolean = false) {
    // return this.openDeleteUnderConstructionDialog();

    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Trabajo",
      message: "Esta seguro que desea eliminar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.deleteTask(task, hardDelete).subscribe(() => {
            this.getTasks(true);
            /*if (hardDelete) this.getTasks(true);
            else {
              task.isDeleted = true;
              //task.status = 'CANCELLED';
            }*/
          })
        }
      });
  }

  openRestoreTaskConfirm(task: ITask) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Restaurar Trabajo",
      message: "Esta seguro que desea restaurar '" + task.title + "'?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.restoreTask(task).subscribe(() => {
            task.isDeleted = false;
          })
        }
      });
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTasks(true);
    });
  }

  clearSelection() {
    this.selection = { all: false, some: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.tasks.every(task => {
        const id = task?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.tasks.forEach(task => {
        const id = task?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }

  openTasksByStatus() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-status']);
  }

  openTasksByList() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-list']);
  }

  openTasksComments() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-comments']);
  }

  openCreateBulkInvoicing() {
    const ids = Object.keys(this.selection).filter(el => el != 'all' && el != 'some' && this.selection[el]);
    let tasks = this.selection.all ? this.tasks : this.tasks.filter(task => ids.find(id => id == task._id));

    // validate same client
    if (tasks.filter(task => task?.client?._id !== tasks[0]?.client?._id).length > 0)
      return this._AlertService.warn("Los Tabajos seleccionados deben corresponder al mismo Cliente");

    const modalOptions: IConfirmationDialogOptions = {
      title: "Generar Factura",
      message: "Está seguro que desea Facturar los Trabajos seleccionados?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {

          let config = new MatDialogConfig();
          config.width = '1200px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
          self.dialogRef.componentInstance.tasks = tasks;
          self.dialogRef.componentInstance.document = {
            type: IBillingDocumentTypes.INVOICE,
            client: tasks[0].client
          };
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.editting = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            // self.dialogRef = null;
            this._router.navigate(['/admin', this._AuthService.companyIndex(), 'billing-documents']).then(() => {
              // window.location.reload();
            });
          });
        }
      });
  }

  /*
  createBulkInvoicing() {
    const ids = Object.keys(this.selection).filter(el => el != 'all' && el != 'some' && this.selection[el]);
    const tasks = this.selection.all ? this.tasks : this.tasks.filter(task => ids.find(id => id == task._id));

    // validate same client
    if (tasks.filter(task => task.client._id != tasks[0].client._id).length > 0)
      return this._AlertService.warn("Los Tabajos seleccionados deben corresponder al mismo Cliente");

    const modalOptions: IConfirmationDialogOptions = {
      title: "Generar Factura",
      message: "Está seguro que desea Facturar los Trabajos seleccionados?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {

          let dueDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()).toISOString();
          let data: IBillingDocument = {
            company: this._AuthService.companyId(),
            client: tasks[0].client._id,
            dueDate: dueDate,

            subtotal: 0,
            tax: 0,
            taxPercentage: 0,
            total: 0,

            details: []
          };
          tasks.forEach(task => {
            data.subtotal += task.subtotal;
            data.tax += task.tax;
            data.total += task.total;

            data.details.push({
              task: task._id,
              // tax: task.tax,
              // taxPercentage: task.taxPercentage,
              // subtotal: task.subtotal,
              total: task.total
            })
          });

          console.log(data);

          this._BillingDocumentService.createInvoice(data).subscribe((doc) => {
            this.getTasks(true)
          });
        }
      });
  }
  */

  openUnderConstructionDialog(cb?: any) {
    const modalOptions: IInformationDialogOptions = {
      title: "Ups!",
      message: "El enlace se encuentra en construccion",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok');
        if (cb) cb();
      });
  }
}